import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

// IMPORTANT: The Supabase email confirmation template must be configured in the
// Supabase dashboard to redirect to:
// https://shieldsme.lognsec.com/confirm-email
// Go to: Authentication → Email → Templates → Confirm signup
// Change the redirect URL in the template to: {{ .SiteURL }}/confirm-email

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: window.localStorage,
    detectSessionInUrl: true,
    flowType: 'implicit',
    autoRefreshToken: true,
  },
});
